"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styleDef = {

  dataphiUploadDocUploadBlock: "dataphi-upload-doc-upload-block",
  dataphiUploadDocUploadBlockContent: "dataphi-upload-doc-upload-block-content",
  dataphiUploadDocTitle: "dataphi-upload-doc-title",
  dataphiUploadDocUploadBlockModal: "dataphi-upload-doc-upload-block-modal",
  dataphiUploadDocUploadImgBtn: "dataphi-upload-doc-upload-img-btn",
  dataphiUploadDocError: "dataphi-upload-doc-error",
  dataphiUploadDocSelectTab: "dataphi-upload-doc-select-tab",
  dataphiUploadDocLabelWidcat: "dataphi-upload-doc-label-widcat",
  dataphiUploadDocLabel: "dataphi-upload-doc-label",
  dataphiUploadDocBadge: "dataphi-upload-doc-badge",
  dataphiUploadDocBtnBadgeBlock: "dataphi-upload-doc-btn-badge-block",
  dataphiUploadDocUploadImgUploadBtnText: "dataphi-upload-doc-upload-img-upload-btn-text",
  dataphiUploadDocBtnProgressBar: "dataphi-upload-doc-btn-progress-bar",
  dataphiUploadDocHeaderDetails: "dataphi-upload-doc-header-details",
  dataphiUploadDocHeaderDetailTitle: "dataphi-upload-doc-header-detail-title",
  dataphiUploadDocUploadBtn: "dataphi-upload-doc-upload-btn",
  dataphiUploadDocUploadBtnDisabled: "dataphi-upload-doc-upload-btn-disabled",
  dataphiUploadDocUploadImgBtnDisabled: "dataphi-upload-doc-upload-img-btn-disabled",
  dataphiUploadDocUploadImg: "dataphi-upload-doc-upload-img",
  dataphiUploadDocUploadImgDefault: "dataphi-upload-doc-upload-img-default"

};

exports.default = styleDef;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dataphi-react-components/dist/Containers/DataphiUploadDocContainer/Component/StyleDef.js
// module id = 1917
// module chunks = 0